import { render, staticRenderFns } from "./SideBarSamples.vue?vue&type=template&id=a65a8e08"
import script from "./SideBarSamples.vue?vue&type=script&lang=js"
export * from "./SideBarSamples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports